class APIS {
	apis() {
		return {
			listAccounts: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/account/list'
			},
			addAccount: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/account/add'
			},
			updateAccount: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/account/update'
			},
			deleteAccount: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/account/delete'
			},
			testConnection: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/account/test'
			},
			syncAccount: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/account/sync'
			},
			getSyncStatus: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/account/sync-status'
			},
			updateSignature: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/account/signature'
			},
			listMessages: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/messages/list'
			},
			listAllMessages: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/messages/all'
			},
			filterContacts: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/messages/filter-contacts'
			},
			getMessage: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/messages/get'
			},
			getThread: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/messages/thread'
			},
			sendEmail: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/messages/send'
			},
			replyEmail: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/messages/reply'
			},
			forwardEmail: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/messages/forward'
			},
			markRead: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/messages/read'
			},
			markAllRead: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/messages/read-all'
			},
			toggleFlag: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/messages/flag'
			},
			moveToFolder: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/messages/move'
			},
			saveDraft: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/messages/draft'
			},
			deleteMessage: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/messages/delete'
			},
			searchMessages: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/messages/search'
			},
			scheduleEmail: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/messages/schedule'
			},
			listScheduled: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/scheduled/list'
			},
			cancelScheduled: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/scheduled/cancel'
			},
			getFolderCounts: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/messages/counts'
			},
			suggestRecipients: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/recipients/suggest'
			},
			listEmailContacts: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/contacts/list'
			},
			listSignatures: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/account/signature/list'
			},
			addSignature: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/account/signature/add'
			},
			editSignature: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/account/signature/update'
			},
			deleteSignature: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/account/signature/delete'
			},
			setDefaultSignature: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/account/signature/set-default'
			},
			uploadEmailImage: {
				headers: { 'xt-user-token': null },
				method: 'post',
				path: '/email-inbox/upload-image'
			}
		};
	}
}

export default new APIS();
